import React from 'react';
import './Clients.css';

const ModalDeactivateClient = ({ closeModal, onConfirm, clientInfo, isSubmitting }) => {
    const handleContainerClick = (event) => {
        if (event.target.className === 'deactivate-modal-backdrop') {
            closeModal();
        }
    };

    const handleCancel = (event) => {
        event.preventDefault();
        closeModal();
    };

    const handleConfirm = (event) => {
        event.preventDefault();
        onConfirm();
    };

    return (
        <div className='deactivate-modal-backdrop' onClick={handleContainerClick}>
            <div className='deactivate-modal-card'>
                <div className='deactivate-modal-header'>Remove Client</div>
                <div className='deactivate-modal-text'>
                    Are you sure you want to remove {clientInfo.first_name} {clientInfo.last_name}?
                </div>
                <div className='deactivate-modal-actions'>
                    <button className='btn' onClick={handleCancel} disabled={isSubmitting}>Cancel</button>
                    <button className='btn deactivate-confirm-btn' onClick={handleConfirm} disabled={isSubmitting}>
                        {isSubmitting ? 'Removing...' : 'Remove'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalDeactivateClient;
